import BasicInput from '@opploans/basic-input-component/BasicInput';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import React from 'react';
import RebrandTooltip from 'components/rebrand/RebrandTooltip';

const tooltipText =
  'For faster processing, enter the name of your income source exactly as it appears on your bank transactions.';

const toolTip = () => (
  <RebrandTooltip
    additionalStyle={{ marginTop: '0.25rem !important' }}
    text={tooltipText}
  />
);

export default {
  defaultNextPage: 'page-7.2.2',
  content: [
    configureProgressBar(32),
    configureTitle('Who do you receive income from?'),
    {
      component: BasicInput,
      props: {
        id: 'nameOfIncome',
        label: 'Name of Income Source',
        type: 'text',
        TooltipComponent: toolTip
      }
    },
    nextButtonConfig('page-7.1.2')
  ]
};
